import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimaryHtml from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-sofyre-tabs-review.js';

const buttonRivoneedHtml = buttonPrimaryHtml({
  text: 'ADD TO CART',
  backgroundColor: '#ccf46f',
  color: '#23372b',
  radius: 100,
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/09/08/image-6a9fb3c9503aaa5482a117ec.png',
  },
});

const starSvg = (count = 5) => {
  let svg = '';
  for (let i = 0; i < count; i++) {
    svg += `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <title>star</title>
        <path
          fill="currentColor"
          d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
        />
      </svg>
    `;
  }
  return svg;
};

const verifiedBadgeSvg = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>check-decagram</title>
    <path
      fill="currentColor"
      d="M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9L10,17Z"
    />
  </svg>
`;

const defaultReviewBody = `
  <blockquote>"Mice got into my grain bins two years running. Lost hundreds of dollars of feed before I even noticed."</blockquote>
  <h3>"BINS HAVE BEEN CLEAN FOR FOUR MONTHS. NOT A SINGLE DROPPING."</h3>
  <p>Placed pouches around every bin entry and along the floor perimeter. Two weeks later the activity stopped completely. No poison near my feed, no dead mice to find. Just gone.</p>
`;

const defaultAvatar = 'https://cdn.skyfastimg.com/images/2026/09/08/image-6a9f7f8cfa0de36dcb936526.webp';

const makeReview = () => ({
  rating: 5,
  bodyContent: defaultReviewBody,
  avatar: defaultAvatar,
  authorName: 'Earl H.',
  authorMeta: '🌾 Farmer · Abilene, Kansas',
  purchaseTag: '3 Pack',
});

const defaultTabs = [
  { tabId: '1', label: '🏠 Homeowners', reviews: [makeReview(), makeReview(), makeReview(), makeReview()] },
  { tabId: '2', label: '🚐 RV Owner', reviews: [makeReview(), makeReview(), makeReview(), makeReview()] },
  { tabId: '3', label: '🌾 Farmers', reviews: [makeReview(), makeReview(), makeReview(), makeReview()] },
];

const renderReviewCard = review => `
  <div class="swiper-slide">
    <div class="review-card">
      <div class="review-card__header">
        <div class="review-card__rating" data-value="${review.rating}" data-attribute="rating">
          ${starSvg(review.rating)}
        </div>
        <div class="review-card__badge">
          ${verifiedBadgeSvg}
          <span> Verified Buyer </span>
        </div>
      </div>
      <div data-attribute="review-card-body" class="review-card__body">
        ${review.bodyContent}
      </div>
      <div class="review-card__footer">
        <div class="avatar">
          <img data-attribute="avatar" src="${review.avatar}" />
        </div>
        <div class="review-card__author-info">
          <div class="review-card__author-name" data-attribute="author-name">${review.authorName}</div>
          <div class="review-card__author-meta" data-attribute="author-meta">${review.authorMeta}</div>
          <span class="review-card__purchase-tag">
            <strong>Purchased:</strong> <span data-attribute="purchase-tag">${review.purchaseTag}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
`;

const renderTabItem = (tab, index) => `
  <div class="tab-item${index === 0 ? ' active' : ''}" data-attribute="tab-item" data-tab="${tab.tabId}">${
  tab.label
}</div>
`;

const renderTabPanel = (tab, index) => `
  <div class="tab-panel${index === 0 ? ' active' : ''}" data-attribute="tab-panel" data-tab="${tab.tabId}">
    <div class="tab-panel__content swiper">
      <div class="swiper-wrapper" data-attribute="list-item">
        ${tab.reviews.map(renderReviewCard).join('\n')}
      </div>
      <div class="wrap-pagination">
      <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
  </div>
`;

const html = `
<div class="container testimonial-section">
  <div class="rating-summary">
    <div
      data-attribute="rating-summary-star"
      data-value="5"
      data-color-star="#ccf46f"
      class="rating-summary__star"
      style="--color-star: #ccf46f"
    >
      ${starSvg(5)}
    </div>
    <div data-attribute="rating-summary-text" class="rating-summary__text">4.8 | 1668 Verified reviews</div>
  </div>
  <div data-show="true" data-attribute="title-testimonial" class="title-testimonial">
    <h2>
      Real Results From <br />
      People Like You
    </h2>
  </div>
  <div
    data-attribute="tab-header"
    class="tab-header"
    data-color-tab="#23372b"
    data-bg-tab-active="#23372b"
    style="--color-tab: #23372b; --bg-tab-active: #23372b"
  >
    ${defaultTabs.map(renderTabItem).join('\n')}
  </div>
  <div
    data-attribute="tab-body"
    class="tab-body"
    data-color-star="#ccf46f"
    data-color-verified-buyer="#365941"
    data-bg-card-item="#F8F8F4"
    style="--color-star: #ccf46f; --color-verified-buyer: #365941; --bg-card-item: #f8f8f4"
  >
    ${defaultTabs.map(renderTabPanel).join('\n')}
  </div>
  <div class="wrap-btn-rivoneed">${buttonRivoneedHtml}</div>
</div>
`;

export default containerFuild(html, css);
